import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";

import { errorHandler } from "../../helpers/Utils";
import { getImumsOptions } from "./imum_action";

export const imumProductTagAction =
  (imum_product_tags, globalTag, context) => async (dispatch) => {
    try {
      imum_product_tags = imum_product_tags.map((d) => {
        if (typeof d.id == "string") return { ...d, id: null };
        return d;
      });
      antdAsyncMessageLoading({ key: "imumProductTagAction" });
      if (context === "retail") {
        await Axios({
          url: `/api/v1/retail_product_tags`,
          data: {
            retail_product_tags: imum_product_tags,
          },
          method: "post",
        });
      } else if (globalTag) {
        await Axios({
          url: `/api/v1/technorama/imum_product_tags`,
          data: {
            imum_product_tags,
          },
          method: "post",
        });
        await Axios({
          url: `/api/v1/bigbox/imum_product_tags`,
          data: {
            imum_product_tags,
          },
          method: "post",
        });
      } else {
        await Axios({
          url: `/api/v1/${window.identifier}/imum_product_tags`,
          data: {
            imum_product_tags,
          },
          method: "post",
        });
      }

      antdAsyncMessageSuccess({ key: "imumProductTagAction" });
      dispatch(getImumsOptions());
      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdAsyncMessageError({ key: "imumProductTagAction" });
      return {
        success: false,
      };
    }
  };
